import { Text } from '@dixa/lib-shared-habla';

import { ConversationAutomationAuditLogEntry } from 'apis/auditLogs';

export type RoutedThroughInternalNoteProps = {
  node: ConversationAutomationAuditLogEntry<'AUTOMATION_INTERNAL_NOTE_NODE_VISITED'>;
};

export function RoutedThroughInternalNote({
  node,
}: RoutedThroughInternalNoteProps): JSX.Element {
  if (node.error) {
    return (
      <Text.Paragraph>
        Internal note · Failed with error: {node.error}
      </Text.Paragraph>
    );
  }

  return (
    <Text.Paragraph>
      Internal note · Automation visited internal note action
    </Text.Paragraph>
  );
}
